import $ from "jquery";
import { mapActions, mapGetters } from "vuex";
import SkeletonLoading from "@/layouts/components/SkeletonLoading.vue";
export default {
  data() {
    return {
      popupRate: false,
      popupCancelMission: false,
      notifiableId: undefined,
      notifiableCode: undefined,
      loadingSubmitTicket: false,
      confirmRateLoad: false,
      rates: [
        {
          value: 1,
          imgSrc: require("@/assets/images/elements/rate5.svg"),
          classNameParent: "rate5",
          className: "active-rate5",
          name: "غير راضي جدا",
        },
        {
          value: 2,
          imgSrc: require("@/assets/images/elements/rate4.svg"),
          classNameParent: "rate4",
          className: "active-rate4",
          name: "غير راضي",
        },
        {
          value: 3,
          imgSrc: require("@/assets/images/elements/rate3.svg"),
          classNameParent: "rate3",
          className: "active-rate3",
          name: "عادي",
        },
        {
          value: 4,
          imgSrc: require("@/assets/images/elements/rate2.svg"),
          classNameParent: "rate2",
          className: "active-rate2",
          name: "راضي",
        },
        {
          value: 5,
          imgSrc: require("@/assets/images/elements/rate1.svg"),
          classNameParent: "rate1",
          className: "active-rate1",
          name: "راضي جدا",
        },
      ].reverse(),
      activeCalss: "",
      rateVlaue: "",
      description: "",
      errMsg: false,
      colorRate: "",
      popupNotification: false,
      popupMandatoryNotification: false,
      popupNotificationData: {},
      popupMandatoryNotificationData: {},
      imgLoading: true,
      cdnUrl: process.env.VUE_APP_CDN_URL,
    };
  },
  components: {
    SkeletonLoading,
  },
  computed: {
    ...mapGetters("dataList", [
      "notfication",
      "unread_mandatory_view_notification",
      "success_api_rate",
      "message",
      "detail_of_order",
    ]),
    ...mapGetters("ticket", ["success", "error_msg", "live_ticket"]),
  },
  methods: {
    ...mapActions("dataList", ["rateOrder", "changeNotificationToRead", "fetchUnreadMandatoryViewNotfication"]),
    ...mapActions("ticket", ["createTicket"]),
    clickNotfication(ntf) {
      if (ntf.type != null && ntf.type == "App\\Models\\Order") {
        let orderCode = ntf.notifiable_code ? ntf.notifiable_code : ntf.notifiable_id;
        this.$router.push("/OrderDetails/" + orderCode);
      } else if (ntf.type != null && ntf.type == "App\\Models\\Mission") {
        this.$router.push("/MissionDetails/" + ntf.notifiable_id);
      } else if (ntf.type != null && ntf.type == "App\\Models\\Mission_cancel") {
        this.popupCancelMission = true;
        this.notifiableId = ntf.notifiable_id;
      } else if (ntf.type != null && ntf.type == "App\\Models\\Order\\Rate") {
        let orderCode = ntf.notifiable_code ? ntf.notifiable_code : ntf.notifiable_id;
        this.$router
          .push({
            path: `/OrderDetails/${orderCode}`,
            query: { popupRate: true },
          })
          .catch(() => {});
      } else if (ntf.type != null && ntf.type == "App\\Models\\ExcelExport") {
        window.location.href =
          process.env.VUE_APP_BASE_URL_EXCEL + ntf.redirect_url;
      } else if (ntf.type != null && ntf.type == "App\\Models\\Ticket") {
        this.$router.push({
          path: `/apps/chat/${ntf.notifiable_id}`,
          query: { type: 1 },
        });
      } else if (ntf.type != null && ntf.type == "App\\Models\\OrderChangeRequest") {
        this.$router.push({ path: '/ChangePriceRequests' });
      } else if (ntf.type != null && ntf.type == "App\\Models\\ReturnRequest") {
        this.$router.push({
          path: `/ReturnRequests`
        });
      } 
      if (ntf.is_manual) {
        this.popupNotificationData = ntf;
        if(ntf.img != '' && ntf.img != null) {
          this.imgLoading = true;
        }
        this.popupNotification = true;
      }
      if (this.$refs.dropdownMenu) {
        this.$refs.dropdownMenu.vsDropdownVisible = false;
        this.$refs.dropdownMenu.$children[0].dropdownVisible = false;
      }
    },
    // Show the next unread notification
    async showNextMandatoryNotification() {
      await this.fetchUnreadMandatoryViewNotfication();

      let notifications = this.unread_mandatory_view_notification;

      const closed = JSON.parse(
        localStorage.getItem("mandatory_notification_closed")
      );

      if (closed) {
        notifications = notifications.filter(
          (n) => n.id !== closed.id
        );
      }

      const nextNotification = notifications[0];

      if (nextNotification) {
        this.popupMandatoryNotificationData = nextNotification;
        if (nextNotification.img && nextNotification.img !== "") {
          this.imgLoading = true;
        }
        this.popupMandatoryNotification = true;
      } else {
        this.popupMandatoryNotification = false;
        this.popupMandatoryNotificationData = null;
      }
    },
    // Close the popup and mark the current notification as read
    async closeMandatoryPopup(popupMandatoryNotificationData) {
      if (popupMandatoryNotificationData) {
        const notificationId = this.popupMandatoryNotificationData.id;

        // Mark the notification as read via action
        await this.changeNotificationToRead({ id: notificationId });

        localStorage.setItem(
          "mandatory_notification_closed",
          JSON.stringify({
            id: notificationId,
            time: Date.now(),
          })
        );

        this.closePopup()
        // Refresh the unread notifications list
        await this.fetchUnreadMandatoryViewNotfication();

        // Show the next notification
        this.showNextMandatoryNotification();
      }
    },
    closePopup() {
      this.popupCancelMission = false;
      this.popupRate = false;
      this.popupNotification = false;
      this.errMsg = false;
      this.popupMandatoryNotification = false;
    },
    activeRate(rate) {
      $(`.single-ticket img`).removeAttr("class");
      $(`.${rate.classNameParent} img`).addClass(rate.className);
      this.activeCalss = $(`.${rate.classNameParent} img`).addClass(
        rate.className
      )[0];
      this.rateVlaue = rate.value;
    },
    async postRate() {
      this.confirmRateLoad = true;
      const obj = {
        order_id: this.detail_of_order.id,
        rate: this.rateVlaue,
        note: this.description,
      };
      await this.rateOrder(obj);
      if (this.success_api_rate == 1) {
        this.errMsg = false;
        this.notficationTost(true, "تم التقييم بنجاح");
        this.$refs.notificationToast.click();
        setTimeout(() => {
          this.closePopup();
        }, 1000);
      } else {
        this.errMsg = true;
      }
      this.confirmRateLoad = false;
    },
    async confirmRateOrder() {
      if (this.rateVlaue != 5 && this.rateVlaue != 4) {
        this.$validator.validateAll().then(async (result) => {
          if (result) {
            this.postRate();
          }
        });
      } else {
        this.postRate();
      }
    },
    async createNewTicket() {
      this.loadingSubmitTicket = true;
      let obj = {
        entityId: this.notifiableId,
        description: "تم الغاء المهمة بدون الرجوع  والاتصال به",
        typeTicket: 2,
        missionComplaint: 1,
      };
      await this.createTicket(obj);
      this.loadingSubmitTicket = false;
      if (this.success == 1) {
        this.errMsg = false;
        this.$router
          .push({
            path: `/apps/chat/${this.live_ticket.id}`,
            query: { type: 1 },
          })
          .catch(() => {});
        this.closePopup();
      } else {
        this.errMsg = true;
      }
    },
    cancelMission() {
      this.popupCancelMission = false;
      this.$router.push("/MissionDetails/" + this.notifiableId);
    },
    onImageLoad() {
      this.imgLoading = false;
    },
  },
  mounted() {
    // Start showing notifications on component mount
    this.showNextMandatoryNotification();

    window.addEventListener("storage", (event) => {
      if (event.key === "mandatory_notification_closed") {
        const data = JSON.parse(event.newValue);

        if (!data) return;

        if (
          this.popupMandatoryNotificationData &&
          this.popupMandatoryNotificationData.id === data.id
        ) {
          this.popupMandatoryNotification = false;
          this.popupMandatoryNotificationData = null;

          this.showNextMandatoryNotification();
        }
      }
    });
  },
};
